<!--

Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Vijay Malekar

-->
<div class="header">
    <div class="icon-list-menu" (click)="mobNav()">
    </div>
    <a tabindex="0" class="header__logo">
        <span class="icon-cisco"></span>
    </a>
    <div class="header__title">
        <!-- <h1>Cisco Application Detectors</h1> -->
        <!-- <h2>Secure Firewall Application Detectors</h2> -->
        <h1 class="fontsize">Secure Firewall Application Detectors</h1>
    </div>
    <div class="header__navigation">
        <ul class="tab-group">
            <li tabindex="0" class="tab-group__tab">
                <a class="tab-group__link" href="home">Home</a>
            </li>
            <li tabindex="0" class="tab-group__tab">
                <a class="tab-group__link" href="relnotes">Release Notes</a>
            </li>
            <li tabindex="0" (click)="toggleDropdown()" class="tab-group__tab">
                <div id="dropdownContainer" class="dropdown">
                    <a class="tab-group__link">Support<span class="icon icon-chevron-down"></span></a>
                    <div class="dropdown__menu" (focusout)="focusOut()" style="width: 17rem;">

                        <a tabindex="0" class="dropdown__item" href="newrequest" class="headerlink">New Application
                            Request</a>
                        <a tabindex="0" class="dropdown__item" href="tacsupport" class="headerlink">Request
                            Application Support</a>
                        <a tabindex="0" class="dropdown__item" (click)="openEncryptedVisibilityEngine()" class="headerlink">Encrypted Visibility
                             Engine Support</a>
                       <!-- <a tabindex="0" class="dropdown__item" href="customdetector" class="headerlink">Custom Detector
                            </a>     -->

                    </div>
                </div>
            </li>
            <li tabindex="0" (click)="toggleDropdown1()" class="tab-group__tab">
                <div id="dropdownContainer1" class="dropdown">
                    <a class="tab-group__link">Documentation<span class="icon icon-chevron-down"></span></a>
                    <div class="dropdown__menu" (focusout)="focusOut()">
                        <a tabindex="0" class="dropdown__item" (click)="openApplicationDetection()"
                            class="headerlink">Application Detection</a>
                        <a tabindex="0" class="dropdown__item" (click)="openOpenId()" class="headerlink">OpenAppID</a>
                        <a tabindex="0" class="dropdown__item" (click)="openYouTubeVideo()" class="headerlink">AppID Portal Intro VoD (8 min)</a>
                        <a tabindex="0" class="dropdown__item" (click)="openEncryptedVisibilityDetails()" class="headerlink">Encrypted Visibility Engine</a>
                    </div>
                </div>
            </li>
            <!-- Sales Tab -->
            <li tabindex="0" (click)="toggleDropdown2()" class="tab-group__tab">
                <div id="dropdownContainer2" class="dropdown">
                    <a class="tab-group__link">Resources<span class="icon icon-chevron-down"></span></a>
                    <div class="dropdown__menu" (focusout)="focusOut()">
                        <a tabindex="0" class="dropdown__item" (click)="openVDBSoftwareDownloads()"
                            class="headerlink">VDB Software Downloads</a>
                        <a tabindex="0" class="dropdown__item" (click)="openProducts()" class="headerlink">Solutions</a>
                        <a tabindex="0" class="dropdown__item" (click)="openPartnerHelp()" class="headerlink">Partner
                            Help</a>

                        <a tabindex="0" class="dropdown__item" (click)="openYouTubeChannel()" class="headerlink">YouTube
                            Channel</a>
                        <a tabindex="0" class="dropdown__item" (click)="openTalos()" class="headerlink">Talos</a>
                        <a tabindex="0" class="dropdown__item" (click)="openDevNetPortal()" class="headerlink">DevNet
                            Portal</a>
                        <a tabindex="0" class="dropdown__item" (click)="openTerraformRegistry()"
                            class="headerlink">Terraform Registry</a>
                        <a tabindex="0" class="dropdown__item" (click)="openLevelUp()" class="headerlink">Level Up</a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="row">
        <div class="header__navigation">
            <ul class="tab-group">
                <div tabindex="0" style="padding: 10px; padding-top: 25px;" class="tab-group__tab">
                    <a class="tab-group__link" routerLink (click)="openModal('desktopModal')">
                        <span>
                            <svg width="11" height="11" viewBox="0 0 16 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.333 0H0.667027C0.488261 0.00237305 0.317715 0.0754651 0.192711 0.203281C0.0677064 0.331096 -0.00157537 0.503226 2.71954e-05 0.682V10.227C-0.00157537 10.4058 0.0677064 10.5779 0.192711 10.7057C0.317715 10.8335 0.488261 10.9066 0.667027 10.909H3.00003V15L7.00003 10.909H15.333C15.5118 10.9066 15.6823 10.8335 15.8073 10.7057C15.9323 10.5779 16.0016 10.4058 16 10.227V0.682C16.0016 0.503226 15.9323 0.331096 15.8073 0.203281C15.6823 0.0754651 15.5118 0.00237305 15.333 0V0Z"
                                    fill="#58585B" />
                            </svg>
                        </span>
                        Feedback</a>
                </div>
            </ul>
        </div>
    </div>
    <!--  <div class="header__toolbar">
            <a tabindex="0" class="header__icon">
                <span class="icon icon-help"></span>
            </a>
            <a tabindex="0" class="header__icon">
                <span class="icon icon-user"></span>
            </a>
        </div> -->
</div>


<div class="mobile-nav" *ngIf="navMenu">
    <div class="mob-head" *ngIf="navMenu" (click)="mobNav()">
        <span class="icon-list-menu"></span>
    </div>
    <ul style="height: 200vh;">
        <li><a href="home">Home</a></li>
        <li><a href="relnotes">Release Notes</a></li>
        <li><a (click)="openSupport()"><span>Support</span> <span class="menu-arrow"><span *ngIf="!supportMenu"
                        class="icon-chevron-right"></span> <span *ngIf="supportMenu"
                        class="icon-chevron-down"></span></span></a>
            <ul *ngIf="supportMenu">
                
                <li><a href="newrequest">New Application Request</a></li>
                <li><a href="tacsupport">Request Application Support</a></li>
                <li><a (click)="openEncryptedVisibilityEngine()">Encrypted Visibility Engine Support</a></li>
                <!-- <li><a href="customdetector">Custom Detector</a></li> -->
            </ul>
        </li>
        <li><a (click)="openDocumentation()">Documentation <span class="menu-arrow"><span *ngIf="!docMenu"
                        class="icon-chevron-right"></span> <span *ngIf="docMenu"
                        class="icon-chevron-down"></span></span></a>
            <ul *ngIf="docMenu">
                <li><a (click)="openApplicationDetection()">Application Detection</a></li>
                <li><a (click)="openOpenId()">OpenAppID</a></li>
                <li><a (click)="openYouTubeVideo()">AppID Portal Intro VoD (8 min)</a></li>
                <li><a (click)="openEncryptedVisibilityDetails()">Encrypted Visibility Engine</a></li>
            </ul>
        </li>
        <li><a (click)="openSales()">Resources<span class="menu-arrow"><span *ngIf="!salesMenu"
                        class="icon-chevron-right"></span> <span *ngIf="salesMenu"
                        class="icon-chevron-down"></span></span></a>
            <ul *ngIf="salesMenu">
                <li><a (click)="openVDBSoftwareDownloads()">VDB Software Downloads</a></li>
                <li><a (click)="openProducts()">Solutions</a></li>
                <li><a (click)="openPartnerHelp()">Partner Help</a></li>

                <li><a (click)="openYouTubeChannel()">YouTube Channel</a></li>
                <li><a (click)="openTalos()">Talos</a></li>
                <li><a (click)="openDevNetPortal()">DevNet Portal</a></li>
                <li><a (click)="openTerraformRegistry()">Terraform Registry</a></li>
                <li><a (click)="openLevelUp()">Level Up</a></li>

            </ul>
        </li>
        <li>
            <a class="tab-group__link" routerLink (click)="openModal('desktopModal')">
                <span>
                    <svg width="11" height="11" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.333 0H0.667027C0.488261 0.00237305 0.317715 0.0754651 0.192711 0.203281C0.0677064 0.331096 -0.00157537 0.503226 2.71954e-05 0.682V10.227C-0.00157537 10.4058 0.0677064 10.5779 0.192711 10.7057C0.317715 10.8335 0.488261 10.9066 0.667027 10.909H3.00003V15L7.00003 10.909H15.333C15.5118 10.9066 15.6823 10.8335 15.8073 10.7057C15.9323 10.5779 16.0016 10.4058 16 10.227V0.682C16.0016 0.503226 15.9323 0.331096 15.8073 0.203281C15.6823 0.0754651 15.5118 0.00237305 15.333 0V0Z"
                            fill="#ffffff" />
                    </svg>
                </span>
                Feedback</a>
        </li>
    </ul>
</div>
<div id="backdrop" class="modal-backdrop"></div>
<div id="desktopModal" class="modal rating modal-alligment">
    <div class="modal__dialog">
        <div class="modal__content">
            <div class="modal__header">
                <div class="modal__title">Feedback</div>
                <a class="modal__close" (click)="closeModal('desktopModal')"><span class="icon-close"></span></a>
            </div>
            <div class="modal__body container-fluid">
                <p class="scale_text">On a scale of 0 to 10, how likely are you likely to recommend this tool to a
                    friend or a colleague?
                </p>

                <div class="row paddings">
                    <div *ngFor="let count of buttonArr">
                        <!-- <button ngDefaultControl  [(ngModel)]="scaleCount" [ngStyle]="{'background-color':getColor(count)}" class="pagination__item pagination__link--type-bordered" mat-raised-button (click)="selectScore(count)">{{count}}</button> -->
                        <button ngDefaultControl
                            [ngClass]="[scaleCount==count+'' ? 'btn--state-selected' :'' ,showScale ? 'showWarningRed'  : '']"
                            [(ngModel)]="scaleCount"
                            class="pagination__item pagination__link--type-bordered mat-raised-button_header"
                            (click)="selectScore(count)">{{count}}</button>

                    </div>
                </div>
                <div class="row">
                    <div class="paddings_notlikely">Not likely</div>
                    <div class="paddings_neutral">Neutral</div>
                    <div class="paddings_extremelylikely">Extremly likely</div>
                </div>

                <div class="row"><label class="scale_text paddings_label">What can we do better?</label></div>
                <textarea ngDefaultControl [(ngModel)]="feedBackDescription" class="feedbackdescription"
                    [ngClass]="showDescription ? 'showWarningRed'  : ''"> </textarea>


                <div class="row"><label class="useremailcolor paddings_label">Email</label></div>
                <input type="text" class="useremail" [(ngModel)]="email"
                    [ngClass]="showEmail ? 'showWarningRed'  : ''" />
                <p>
                    <label class="checkbox">
                        <input type="checkbox" class="checkbox__input" checked ngDefaultControl
                            [(ngModel)]="contactPersmission">
                        <div class="checkbox__box"></div>
                        <div class="checkbox__label scale_text">May we contact you regarding your feedback?</div>
                    </label>
                    <!-- <label class="checkbox">
                        <input type="checkbox" class="checkbox__input">
                        <div class="checkbox__box"></div>
                        <div class="checkbox__label scale_text">Do not show me this again</div>
                    </label> -->
                </p>
                <div [ngClass]="showScale ? 'showWarningsBlock'  : 'showWarningsNone'">Please select a scale from 0 to
                    10.</div>
                <div [ngClass]="showDescription ? 'showWarningsBlock'  : 'showWarningsNone'">Please share your
                    description.</div>
                <div [ngClass]="showEmail ? 'showWarningsBlock'  : 'showWarningsNone'">Please enter valid email, so we
                    can contact you.</div>
            </div>
            <div class="modal__footer">
                <!-- <div class="row"> -->
                <div class="col-md-6" style="text-align: left;">
                    <a href="http://www.cisco.com/web/siteassets/legal/privacy.html" target="_blank"><span
                            class="privacypolicy" style="color:#0083B3 ;">Privacy Policy</span>
                        <svg width="15" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M8.94833 8.9475H1.0525V1.05167H5.52667V0H0.526667C0.236667 0 0 0.235833 0 0.526667V9.47333C0 9.76333 0.236667 10 0.526667 10H9.47333C9.76417 10 10 9.76333 10 9.47333V4.47333H8.94833V8.9475ZM9.13254 3.14794C9.25679 3.27219 9.38185 3.23214 9.41127 3.05966L9.9998 0L6.93375 0.582013C6.76128 0.611441 6.72123 0.737326 6.84466 0.861576L7.62608 1.64304L5.98394 3.28527C5.78286 3.48636 5.78286 3.81415 5.98394 4.01524C6.18584 4.21714 6.51198 4.21714 6.71387 4.01524L8.35683 2.37219L9.13254 3.14794Z"
                                fill="#58585B" />
                        </svg>
                    </a>
                </div>

                <div class="col-md-6" style="text-align: right;">
                    <button class="btn btn--primary" (click)="submitFeedback()">Submit</button>
                </div>

                <!-- </div> -->


            </div>
        </div>
    </div>
</div>

<div id="submitModal" class="modal modal--size-small submitted-modal-alligment">
    <div class="modal__dialog">
        <div class="modal__content">
            <div class="modal__header">
                <div class="modal__title">Thank you</div>
                <a class="modal__close" (click)="closeModal('submitModal')"><span class="icon-close"></span></a>
            </div>
            <div class="modal__body">
                <p>Your submission has been received.</p>
            </div>

        </div>
    </div>
</div>